<!--
 * @Deccription:
 * @Author: zjg
 * @Date: 2020-04-04 09:45:11
 * @LastEditTime: 2020-04-04 10:20:31
 -->
<template>
  <section>
    <!--创建分享外联-->
    <co-dialog
      v-model="shareLink.showDialog"
      :show-footer="false"
      :title="shareLink.dialogTitle"
    >
      <!--分享外链的组件-->
      <link-share
        ref="share"
        :share-type="shareLink.shareType"
        :other-data="shareLink.otherData"
        @changeDialog="changeDialog"
        @reqApproval="reqApproval"
      />
    </co-dialog>

    <!--审批组件-->
    <bs-approval
      ref="bsapproval"
      :other-data="apporvalData"
      :is-third-party="isThirdparty"
    />
    <!--loading img-->
    <div
      v-show="loading"
      class="mask"
    >
      <img
        src="~image/search-load.gif"
      >
    </div>
  </section>
</template>

<script>
import _$ from 'js/api/getdata'
import coDialog from 'components/common/dialog/index.vue'
import bsApproval from 'components/business/approval/request-approval.vue'
import { SHARE_TYPE } from 'components/business/linkshare/index'
import isExistPolicy from 'components/business/approval/request-approval'
import linkShare from './index.vue'
import { LINK_SHARE_PREPARATION } from '../../../static/js/linkshare-service/linkSharePreparation'

export default {
  name: 'linkShareDispatch',
  components: {
    coDialog,
    linkShare,
    bsApproval,
  },
  mixins: [LINK_SHARE_PREPARATION],
  props: {
    currentData: { // 当前文件对象
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      shareLink: { // 外链部分
        showDialog: false, // 外链弹窗
        dialogTitle: this.$t('链接分享'), // 名称
        shareType: SHARE_TYPE.commonLink, // 外链分享类型
        otherData: {}, // 创建的请求参数
      },
      apporvalData: {}, // 审批外链的参数
      loading: false,
      isThirdparty: false,
    }
  },
  methods: {
    /**
         * 创建外链
         */
    create(name) {
      // 初始化赋值
      this.shareLink.shareType = name
      // 显示弹窗
      this.changeDialog(name)
      // 判断文件的数量,邮箱验证,odc,私有不需要，暂时注释，TODO:后期删除
      // linkNum(this.currentData, (res) => {
      //   if (res) {
      //     // 判断创建外链的权限
      //     checkCanCreate(name, this.currentData, (checkInfo) => {
      //       // 打印返回的数据
      //       if (checkInfo.flag) {
      //         // 初始化赋值
      //         this.shareLink.shareType = name
      //         this.shareLink.otherData = Object.assign(res, checkInfo.mixData, { meta: this.currentData })
      //         // 显示弹窗
      //         this.shareLink.showDialog = true
      //         this.changeDialog(name)
      //       }
      //     })
      //   }
      // })
    },
    /**
         * 修改弹窗的样式
         */
    changeDialog(name, data = {}) {
      if (name === 'history' || name === 'mgdelivery') {
        this.shareLink.dialogTitle = this.$t('历史链接')
      } else if (name === 'close') {
        this.shareLink.showDialog = false
      } else {
        this.shareLink.dialogTitle = this.$t('链接分享')
        this.newLinkShareDataProcessing('commonLink', this.currentData)
      }
    },
    /**
         * 审批外链
         */
    async reqApproval(d) {
      this.apporvalData = d
      this.apporvalData.approvalType = 'delivery'
      const { neid, nsid, path } = this.currentData
      isExistPolicy({ neid, nsid, path }, 'delivery').catch((error) => {
        if (error.data) {
          if (error.data.length === 0) {
            window.$toast.simpleShow(this.$t('该审批规则没有审批者，请联系管理员'), 'warn')
          } else {
            this.apporvalData.approvers = error.data
            _$.getData('isThirdParty').then((res) => {
              if (res.status === 200) {
                this.isThirdparty = res.data.result
                this.$refs.bsapproval.show()
              }
            }).catch(() => {
            })
          }
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
  .mask{
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 100;
    background-color: rgba(255,255,255,0.4);
    img{
      position: absolute;
      left: 0;
      right: 0;
      width: 60px;
      height: 60px;
      top: 40%;
      margin: auto;
      display: block;
    }
  }
</style>
